module.exports = require("./is-IS");